import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { MemoraiSkeleton } from '../../lib/components/memorai';
import { ROUTES } from '../../lib/routes';
import { useTranslations } from '@memorai/i18n';

export const AuthGuard = ({ children }: { children: React.ReactNode }) => {
    const { session, loading } = useAuth();
    const location = useLocation();
    const { t } = useTranslations('common');

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-background">
                <div className="space-y-4 text-center">
                    <MemoraiSkeleton className="h-12 w-12 rounded-full mx-auto" />
                    <p className="text-foreground-subtle animate-pulse">{t('actions.loading')}</p>
                </div>
            </div>
        );
    }

    if (!session) {
        return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
    }

    return <>{children}</>;
};
